var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageContainer',{attrs:{"title":"Dashboard"}},[_c('InfoWidgets'),_c('div',{staticClass:"row-container"},[_c('AulasInfo'),_c('RankInstrutores')],1),_c('NotificationsSection'),_c('AulasPorVeiculo')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }